import { useState, useEffect, createContext, useContext } from 'react'

// ============================================
// COULEURS MANRINA (Charte officielle)
// ============================================
export const MANRINA_COLORS = {
  orange: 'rgb(var(--c-primary))',
  vert: 'rgb(var(--c-green))',
  creme: 'rgb(var(--c-creme))',
}

// ============================================
// ZONES
// ============================================
export const ZONES = {
  ALIMENTAIRE: { label: 'Alimentaire', color: 'from-green-500 to-emerald-600', bg: 'bg-green-50 text-green-700' },
  ARTISANAT: { label: 'Artisanat', color: 'from-amber-500 to-orange-600', bg: 'bg-amber-50 text-amber-700' },
  BIEN_ETRE: { label: 'Bien-être', color: 'from-purple-500 to-violet-600', bg: 'bg-purple-50 text-purple-700' },
  SERVICES: { label: 'Services', color: 'from-blue-500 to-cyan-600', bg: 'bg-blue-50 text-blue-700' },
  DIVERS: { label: 'Divers', color: 'from-gray-500 to-slate-600', bg: 'bg-gray-100 text-gray-600' },
}

export function getZone(code) {
  return ZONES[code] || ZONES.DIVERS
}

// ============================================
// THEME CONTEXT (Web2 / Web3)
// ============================================
const ThemeContext = createContext()

export function useTheme() {
  return useContext(ThemeContext)
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('lyannaj-theme') || 'web2'
    }
    return 'web2'
  })

  const toggleTheme = () => {
    const newTheme = theme === 'web2' ? 'web3' : 'web2'
    setTheme(newTheme)
    localStorage.setItem('lyannaj-theme', newTheme)
  }

  const isWeb3 = theme === 'web3'

  // Expose le theme au CSS via data-theme pour que les tokens (index.css)
  // s'adaptent automatiquement, sans pattern isWeb3 dans chaque composant.
  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.documentElement.dataset.theme = theme
    }
  }, [theme])

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, isWeb3 }}>
      {children}
    </ThemeContext.Provider>
  )
}
